import { useQuery } from '@tanstack/react-query';

import { applicationsApi } from '../api/applications-api';

import { applicationKeys } from './application-keys';

export const COUNTS_POLL_MS = 60_000;

/**
 * Applications per status for the sidebar badge. The list endpoint carries the counts whatever
 * the filters, so one row is enough. Polled; a failure leaves the badge off rather than toasting.
 */
export function useApplicationCounts() {
  return useQuery({
    queryKey: applicationKeys.counts(),
    queryFn: async () => (await applicationsApi.list({ limit: 1 })).counts,
    refetchInterval: COUNTS_POLL_MS,
    staleTime: COUNTS_POLL_MS / 2,
    meta: { silentError: true },
  });
}
